<template>
  <Layout>
    <div class="row">
      <div class="col-lg-6 mx-auto">
        <div class="card">
          <div class="card-body">
            <center><i class="mdi mdi-lock mdi-36px"></i> <br> <b>Change Password</b></center>
            <form @submit.prevent="UpdateProfile">
                <!-- <div class="form-group mb-2">
                    <b-form-group label="Old Password">
                    <input v-model="oldpassword" type="password" class="form-control text-primary" />
                    </b-form-group>
                </div>   -->
                <div class="form-group mb-2">
                    <b-form-group label="New Password">
                    <input v-model="newpassword" type="text" class="form-control text-primary" />
                    </b-form-group>
                </div> 
                <div class="form-group mb-2">
                    <b-form-group label="Repeat Password">
                    <input v-model="repeatpassword" @input="CheckPassword" type="text" class="form-control text-primary" />
                    </b-form-group>
                </div> 
                <div class="form-group"><br>
                    <b-button type="submit" :disabled="checkpsd" class="btn w-100" variant="primary"><i class="fas fa-check-circle"></i> Change</b-button>
                </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";

export default {
  page: {
    title: "School Profile",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,
  },
  data() {
    return {
      oldpassword: "",
      newpassword: "",
      repeatpassword: "",
      checkpsd:true,
    };
  },
  methods: {
    CheckPassword(){
        if (this.newpassword==this.repeatpassword) {
            this.checkpsd=false;
        }
    },
    async UpdateProfile() { 
        const config = { headers: { 'content-type': 'multipart/form-data' } };
        let formData = new FormData();
        formData.append("oldpassword", this.oldpassword);
        formData.append("newpassword", this.newpassword);
        formData.append("repeatpassword", this.repeatpassword);
        let url = "/changepassword";
        await axios.post(url, formData, config).then((response) => {
        if (response.status == 200) {
            this.oldpassword="";
            this.newpassword="";
            this.repeatpassword="";
            this.$swal({ title:'Success', text:response.data.message, icon:'success'});
        }else{
            this.oldpassword="";
            this.newpassword="";
            this.repeatpassword="";
            // this.$toast.success(response.data.message);
            this.$swal({ title:'Error', text:response.data.message, icon:'info'});

        }
        });
      },
  },
};
</script>